import React from 'react';
import { NavLink, Link } from 'react-router-dom';

import { createPaginationClassName } from './paginationStyles';

type TProps = {
  text: React.ReactNode;
  to: string;
  asNavLink?: boolean;
};

export const PaginationLink = (props: TProps) => {
  const { text, to, asNavLink } = props;

  if (asNavLink) {
    return (
      <NavLink
        to={to}
        className={createPaginationClassName('link', { nav: true })}
        activeClassName={createPaginationClassName('link', { active: true })}
      >
        {text}
      </NavLink>
    );
  }

  return (
    <Link to={to} className={createPaginationClassName('link')}>
      {text}
    </Link>
  );
};
